export const isLoggedIn = () => {
  return !!sessionStorage.getItem('token');
};

export const getRole = () => {
  return sessionStorage.getItem('role') || '';
};

export const getUsername = () => {
  return sessionStorage.getItem('username') || '';
};

export const getUserId = () => {
  const id = sessionStorage.getItem('userId');
  return id ? parseInt(id, 10) : null;
};

export const isMobile = () => {
  return window.innerWidth <= 767;
};